/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import deleteImage from "actionbar/delete-icon-18.svg";
import { webComponentShim } from "components/shared/WebComponentShim";
import styled from "styled-components";

const ActionButton = styled(webComponentShim("sp-action-button"))`
  width: 40px;
  height: 40px;
  padding: 0;
`;

const DeleteIcon = styled.img`
  width: 18px;
  height: 18px;
`;

interface DeleteButtonProps {
  isDeleting: boolean;
  performDelete: VoidFunction;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  isDeleting,
  performDelete,
}) => {
  const onClick = (e: React.MouseEvent): void => {
    performDelete();
    e.stopPropagation();
  };

  return (
    <ActionButton
      disabled={isDeleting || undefined}
      onClick={onClick}
      label={I18n.t("enhance_speech.delete")}
    >
      {isDeleting ? (
        <sp-progress-circle size="s" indeterminate />
      ) : (
        <DeleteIcon src={`${deleteImage}#delete-icon-18`} />
      )}
    </ActionButton>
  );
};
